import * as core from '../../../../../../../core'

import { query } from './assets-by-platform.query'

export const RESOURCE = {
  payload: {
    alias: 'assets.by.platform',
    description: 'Assets by AI Platform',
    name: 'Assets by Platform',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
